import api from './authApi';

/**
 * Get the logged-in teacher's profile
 * Returns teacher document with populated user info
 */
export const getTeacherProfile = async () => {
  try {
    const response = await api.get('/teachers/profile');
    const data = response.data;
    
    // Handle wrapped response: {success: true, data: {...}}
    if (data.success && data.data) {
      return data.data;
    }
    
    // Handle direct response
    return data;
  } catch (error) {
    console.error('Error fetching teacher profile:', error);
    throw error;
  }
};

/**
 * Update teacher profile
 */
export const updateTeacherProfile = async ({ teacherId, updates }) => {
  try {
    if (!teacherId) {
      throw new Error('Teacher ID is required to update the profile');
    }

    const response = await api.patch(`/teachers/${teacherId}`, updates);
    const data = response.data;

    if (data && typeof data === 'object' && data.success && data.data) {
      return data.data;
    }

    return data;
  } catch (error) {
    console.error('Error updating teacher profile:', error);
    throw error;
  }
};

/**
 * Get teacher statistics and dashboard data
 */
export const getStaffDashboard = async () => {
  try {
    const response = await api.get('/staff/dashboard');
    const data = response.data;

    if (data && typeof data === 'object' && data.success && data.data) {
      return data.data;
    }

    return data;
  } catch (error) {
    console.error('Error fetching staff dashboard:', error);
    throw error;
  }
};

export const getStaffStatistics = async () => {
  try {
    const response = await api.get('/staff/dashboard/statistics');
    const data = response.data;

    if (data && typeof data === 'object' && data.success && data.data) {
      return data.data;
    }

    return data;
  } catch (error) {
    console.error('Error fetching staff statistics:', error);
    throw error;
  }
};

export const teacherApi = {
  getTeacherProfile,
  updateTeacherProfile,
  getStaffDashboard,
  getStaffStatistics,
};

export default teacherApi;
